import { Form, Formik } from 'formik';
import { useCallback, useState } from 'react';

import { initalAdjustmentValue } from '@modules/ContactManager/components/Tabs/components/Deals/components/Tiles/components/FinanceModal';
import { IAddAdjustment } from '@modules/ContactManager/components/Tabs/components/Deals/components/Tiles/interfaces';
import { createDealSheetAdjustment } from '@modules/ContactManager/components/Tabs/components/Deals/components/Tiles/queries';
import { IDealSheetAdjustment } from '@modules/ContactManager/components/Tabs/components/Deals/interfaces';
import { Modal } from '@shared/components/modals/Modal';

import { IAdjustmentModalProps } from '../interfaces';
import { AdjustmentForm } from './AdjustmentForm';

export const AdjustmentModal = ({ dealId, contactId, setOpenAdjustmentModal, refresh }: IAdjustmentModalProps) => {
  const [loading, setLoading] = useState(false);

  const handleSave = useCallback(async (data: IAddAdjustment) => {
    const createData: IDealSheetAdjustment = {
      dealId: dealId ?? '',
      contactId: contactId ?? '',
      amountFinanced: data.amountToFinanceFlat ?? 0,
      adjPayOff: data.adjustedPayoff ?? 0,
      totalAdjustment: data.totalAdjustment ?? 0,
    };

    setLoading(true);
    await createDealSheetAdjustment(createData);
    await refresh?.();
    setLoading(false);
    setOpenAdjustmentModal(false);
  }, [dealId, contactId]);

  return (
    <Modal
      open
      title='Add Adjustment'
      onClose={() => setOpenAdjustmentModal(false)}
    >
      <Formik
        enableReinitialize
        initialValues={initalAdjustmentValue}
        onSubmit={handleSave}
      >
        {(props) => (
          <Form onSubmit={props.handleSubmit}>
            <AdjustmentForm loading={loading} setOpenAdjustmentModal={setOpenAdjustmentModal} />
          </Form>
        )}
      </Formik>
    </Modal>
  );
};